// extracted by mini-css-extract-plugin
module.exports = {"content":"HeaderProfile_content__3c6WR","menuBtn":"HeaderProfile_menuBtn__3BX9x","avatar":"HeaderProfile_avatar__19a_f","profileBtn":"HeaderProfile_profileBtn__3wXh2"};